// COOKIE
function addZeros(value, len) {
    value = '' + value;
    if (value.length < len) {
      for (var i = 0; i < len - value.length; i++) {
        value = '0' + value;
      }
    }
    return value;
};

$(document).ajaxComplete(function(event, xhr, settings) {
    // reinit facebook
    if (!xhr.responseText) return;
    var response = JSON.parse(xhr.responseText);
    // response = response.data;
    if (typeof response === 'undefined') return;
    if (response.error == 1) {
        if (!response.message) return;
        swal({
            title: response.title,
            html: response.message,
            type: 'error',
            timer: 3000,
            showConfirmButton: false
        }).catch(swal.noop);
        return;
    }
    if (typeof response.action == 'undefined' || response.action == '') return;
    var timeout;
    $.each(response.action.trim().split(' '), function(index, action) {
        if (action == 'redirect') {
            timeout = response.action.trim().split(' ').length > 1 ? 3000 : 500;
            setTimeout(function() {
                window.location.href = response.link;
            }, timeout);
        }
        if (action == 'redirect_suddenly') {
            window.location.href = response.link;
        }

        if (action == 'reload') {
            timeout = response.action.trim().split(' ').length > 1 ? 3000 : 500;
            setTimeout(function() {
                window.location.reload();
            }, timeout);
        }

        if (action == 'sweetalert') {
            Swal.fire({
                title: response.title,
                html: response.message,
                type: response.command,
                timer: 0,
                showConfirmButton: true
            });
        }

        if (action == 'replace') {
            $(response.js_class).html(response.html);
        }
        if (action == 'replacewith') {
            $(response.js_class).replaceWith(response.html);
        }

        if (action == 'append') {
            $(response.js_class).append(response.html);

            if(typeof lozad === 'function'){
                const observer = lozad('.lozad', {
                    rootMargin: '10px 0px', // syntax similar to that of CSS Margin
                    threshold: 0.1 // ratio of element convergence
                });
                observer.observe();
            }
        }

        if (action == 'scroll_to_top') {
            $('html, body').animate({
                    scrollTop: $('body').offset().top + 'px'
                },
                'slow'
            );
        }

        if (action == 'toastr') {
            toastr.options = {
                closeButton: true,
                showDuration: '300',
                hideDuration: '2000',
                timeOut: '5000'
            };
            if (response.command == 'success') {
                toastr.success(response.message, response.title);
            } else if (response.command == 'info') {
                toastr.info(response.message, response.title);
            } else if (response.command == 'waring') {
                toastr.warning(response.message, response.title);
            } else if (response.command == 'error') {
                toastr.error(response.message, response.title);
            } else {
                toastr.info(response.message, response.title);
            }
        }
    });
});

// $(document).ready(function() {
jQuery(function($){
    var Window = $(window);
    var jBody = $(document.body);
    var quaythutimeout;
    var keno_current_done = false;
    var ngay = false;
    var tooltip = false;

    layout();
    configViewTableResult();
    reloadData();
    quayThuKqxs();
    filterTanSuat();
    thongKeLotoXoSo();
    quayThuPower();
    quayThuMega();
    loadMoreKeno();
    refreshPage();
    loadMoreKqxs();
    loadMorePostItem();
    switchAds();
    processTooltip();
    processSubmitFormFront();
    affAdds();

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    function layout() {

        $('.js_btn_phongto_tansuat').on('click', function(e) {
            e.preventDefault();
            jBody.toggleClass('fullscreen_tansuat');
            $('.js_btn_phongto_tansuat.phongto').toggleClass('hidden');
            $('.js_btn_phongto_tansuat.thunho').toggleClass('hidden');

            $('.div_tansuat_wrapper').height(
                Window.height() - $('.table_tansuat_filter').height() - 24
            );
        });


        $('.js-nav-tabs-button').on('click', function () {
            $('.js-nav-tabs-button').removeClass('fw-semibold text-red border-bottom border-danger');
            $(this).addClass('fw-semibold text-red border-bottom border-danger');
            var data_tab_target = $(this).attr('data-tab-target');
            $('.js-nav-tabs-content').addClass('d-none');
            $(data_tab_target).removeClass('d-none');
        })

        $('.js-scroll-to-top').on('click', function (e) {
            $('html,body').animate({ scrollTop: 0 }, '500');
        });

        $('.js-btn-menu, .panel-backdrop, .js-close-menu').on('click', function(){
            $('body').toggleClass('active-menu-mobile');
        });

        // NEW SAVE xoso

        $('.js-thong-ke-redirect-form').on('submit', function(event) {
            event.preventDefault();
            var _self = $(this);

            var _text = _self.find('button').html();
            _self.find('button').html('Đang xử lý...');
            $.ajax({
                url: base_api_url+'get/page/thongke',
                data: _self.serialize(),
                type: 'post',
                success: function(res) {
                    _self.find('button').html(_text);
                    if (!res.error) {
                        _self.find('button').html(_text);
                        window.location.href = res.link;
                    }
                }
            });
        });

        $('.js-thong-ke-redirect-form select').on('change', function(){
            $('.js-thong-ke-redirect-form').trigger('submit');
        });

        // do ket qua
        $('.js-chontinhthanh').on('change', function(e){
            $('.js-btn-find-post-with-day').trigger('click');    
        });

        $('.js-btn-find-post-with-day').on('click', function(e) {
            e.preventDefault();

            var _self = $(this);

            var day = _self.closest('form').find('.chonngay_xoso').val();
            var page_id = _self.closest('form').find('.js-chontinhthanh').val();

            if (!day || !page_id) {
                alert('Xin hãy chọn một ngày để xem');
                return;
            }

            $.ajax({
                url: atrungroi_ajax.ajaxurl,
                data: {
                    action: 'find_exactly_post',
                    ngay: day,
                    page_id: page_id
                },
                type: 'post',
                success: function(data) {
                    //console.log(data);
                    if (data.success) {
                        window.location.href = data.data.link;
                    }
                }
            });
        });

        $('.js-go-to').on('click', function(e) {
            e.preventDefault();

            var id = $(this).attr('href') || $(this).attr('id');
            $('html, body').animate({
                    scrollTop: $(id).offset().top - 45 + 'px'
                },0
            );
        });

        // init random
        generateNumber();

        // redirect select 
        $('.js-select-other-day').on('change', function(e){
            window.location.href = $(this).val();
        });

        // lozad
        if(typeof lozad === 'function'){
            const observer = lozad('.lozad', {
                rootMargin: '10px 0px', // syntax similar to that of CSS Margin
                threshold: 0.1 // ratio of element convergence
            });
            observer.observe();
        }

        // readmore
        $('.js-btn-readmore').on('click', function(e){
            e.preventDefault();

            $('.js-bottom-content').removeClass('has-readmore');
        });

        if (typeof $.fn.datepicker === 'function'){
            $('.js-date-picker').datepicker({
                inline: true,
                format: 'dd/mm/yyyy',
                language: 'vi',
                autoclose: true,
                todayHighlight: true,
                endDate: currentDate
            }).on('changeDate', function(e) {
                var ngay = $(this).val();
                $.ajax({
                    url: atrungroi_ajax.ajaxurl,
                    data: { action: 'load_province_by_date', ngay: ngay },
                    type: 'post',
                    success: function(data) {
                        if (data.success) {
                            $('.js-chon-mien-tinh').html(data.data.html);
                        }
                    }
                });
            });

            var currentDate = new Date();
            $('.chonngay_xoso').datepicker({
                inline: true,
                format: 'dd/mm/yyyy',
                language: 'vi',
                autoclose: true,
                todayHighlight: true,
                endDate: currentDate
            }).on('changeDate', function(e) {
                var day = $.format.date(e.date, 'dd/MM/yyyy');
        
                $.ajax({
                  url: atrungroi_ajax.ajaxurl,
                  data: { action: 'load_page_by_date', ngay: day },
                  type: 'post',
                  success: function(data) {
                    $('.preload').remove();
                    if (data.success) {
                      $('.js-chontinhthanh').html(data.data.html);
                    }
                  }
                });
            });

            // datepicker theo mien tinh
            $('.js-date-picker-mien-tinh').each(function(index, el){

                var enabledDays = $(this).attr('data-weekday') || [];
                var province_id = $(this).attr('data-province');
                var mien_id = $(this).attr('data-mien');
                $(this).datepicker({
                    language: 'vi',
                    maxDate: new Date(),
                    dateFormat: 'd/m/yyyy',
                    onRenderCell: function (date, cellType) {
                        if (cellType == 'day') {
                            var day = date.getDay(),
                                isDisabled = enabledDays.indexOf(day) != -1 ? 0 : 1;
    
                            return {
                                disabled: isDisabled
                            };
                        }
                    },
                    onSelect: function onSelect(fd, date) {
                        var selected_day = date.getFullYear() +'-'+self.pad(date.getMonth()+1,2)+'-'+self.pad(date.getDate(), 2);
    
                        $.ajax({
                            type:'POST',
                            url:base_api_url+'get/post/xoso',
                            data:{ngay:selected_day, 'province_id':province_id, 'mien_id':mien_id},
                            success: function(data) {
                                //console.log(data);
                                if (data.success) {
                                    window.location.href = data.data.link;
                                }
                            }
                        });
                    }
                });
            });

            if($('.js-date-picker-vietlott').length){
                ngay = $('.js-date-picker-vietlott').attr('data-ngay');
                $('.js-date-picker-vietlott').datepicker({
                    inline: true,
                    format: 'dd/mm/yyyy',
                    language: 'vi',
                    autoclose: true,
                    todayHighlight: false,
                    endDate: currentDate,
                    daysOfWeekDisabled: $('.js-date-picker-vietlott').attr('day-of-week'),
                    daysOfWeekHighlighted: $('.js-date-picker-vietlott').attr('day-of-week-used'),
                    beforeShowDay: highlightDays
                }).on('changeDate', function(e) {
                    var day = $.format.date(e.date, 'yyyy-MM-dd');
                    var _self = $(this);
                    $.ajax({
                        url: base_api_url+'get/post/vietlott',
                        data: {
                            ngay: day,
                            type: _self.attr('data-type')
                        },
                        type: 'POST',
                        success: function(res) {
                            //console.log(data);
                            if (!res.error) {
                                window.location.href = res.link;
                            }
                        }
                    });
                });
            }
        }

        // sidebar province
        $('.js-select-type-quay-thu').on('change', function(e){
            if($(this).val() == 'birthday'){
                $('.js-birthday-select-wrap').removeClass('hidden');
            }else{
                $('.js-birthday-select-wrap').addClass('hidden');
            }
        });
    }

    function highlightDays(date) {
        if (ngay == '') return [true, ''];
        date = $.format.date(date, 'dd/MM/yyyy');
        if (ngay === date) {
            return {
                tooltip: 'Kết quả ngày ' + date,
                classes: 'hightlight'
            };
        }
        return {
            tooltip: 'Kết quả ngày ' + date,
            classes: ''
        };
    }

    function generateNumber(speed) {
        speed = speed || 100;
        $('.js-loading-number.next').each(function(index, ele) {
            var el = $(ele);

            if (el.attr('has-animate') == 1) return;

            var animationTimer = setInterval(function() {
                if (!el.hasClass('loading')) {
                    clearInterval(animationTimer); // Stop the loop
                } else {
                    var giai = el.attr('data-id-giai');
                    var html = '';

                    var is_mienbac =
                        el.closest('.js-load-more-mien-bac').length > 0 ? true : false;
                    if (giai == 9) {
                        html =
                            '' +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10);
                    }
                    if (giai == 8) {
                        html =
                            '' +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10);
                    }

                    if (giai == 7 || giai == 6) {
                        html =
                            '' +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10);
                    }

                    if (giai == 5 || giai == 4 || giai == 3 || giai == 2) {
                        html =
                            '' +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10);
                    }

                    if (giai == 1) {
                        html =
                            '' +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10) +
                            Math.floor(Math.random() * 10);
                    }

                    if (is_mienbac) {
                        if (giai == 8) {
                            html =
                                '' +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10);
                        }
                        if (giai == 7) {
                            html =
                                '' +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10);
                        }

                        if (giai == 6 || giai == 5) {
                            html =
                                '' +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10);
                        }

                        if (giai == 4 || giai == 3 || giai == 2 || giai == 1) {
                            html =
                                '' +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10) +
                                Math.floor(Math.random() * 10);
                        }
                    }

                    el.html(html);
                    el.attr('has-animate', 1);
                }
            }, speed);
        });
    }

    function getResult(id_ketqua, mien, quaythu, timeout) {
        quaythu = quaythu || 0;
        timeout = timeout || 2000;
        var date = new Date();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var url_quay = base_url+'jsons/';
        if (quaythu) {
            url_quay = base_url+'quaythu/';
        }
        $.getJSON(url_quay + id_ketqua + '.json?t=' + date.getTime(), function(data) {
            var has_class_next = false;
            $.each(data, function(k, v) {
                if (!v.number) {
                    if (!has_class_next) {
                        if ((mien == 2 || mien == 'Xổ Số Miền Nam') && hour >= 16 && minutes > 10) {
                            $('#number_' + v.id).addClass('next');
                        }

                        if ((mien == 7 || mien == 'Xổ Số Miền Trung') && hour >= 17 && minutes > 10) {
                            $('#number_' + v.id).addClass('next');
                        }

                        if ((mien == 11 || mien == 'Xổ số Miền Bắc') && hour >= 18 && minutes > 10) {
                            $('#number_' + v.id).addClass('next');
                        }
                        has_class_next = true;
                        generateNumber();
                    }
                }else{
                    if (quaythu) {
                        setTimeout(function() {
                            $('.number').removeClass('next');
                            if (isNaN($('#number_' + v.id).html())) {
                                $('#number_' + v.id).addClass('next');
                            }
    
                            has_class_next = true;
                            generateNumber();
    
                            setTimeout(function() {
                                if (v.number != '') {
                                    $('#number_' + v.id).removeClass('loading js-loading-number');
                                    has_class_next = false;
    
                                    setTimeout(function() {
                                        $('#number_' + v.id).html(v.number).attr('data-num', v.number);
                                    }, 170);
                                }
                            }, 2000);
                        }, (k + 1) * timeout);
                    } else {
                        if (k == 0 && v.number != '') {
                            // if (notification_sound) {
                            //     if (
                            //         ($('#number_' + v.id).html() != v.number &&
                            //             $('#number_' + v.id)
                            //             .closest('.table_result')
                            //             .attr('data-mien') == mien) ||
                            //         $('#number_' + v.id)
                            //         .closest('.table_result')
                            //         .attr('data-mien') === 'undefined'
                            //     ) {
                            //         notification_sound.play();
                            //     }
                            // }   
                        }
                        $('#number_' + v.id).removeClass('loading').html(v.number).attr('data-num', v.number).removeClass('js-loading-number');
                        has_class_next = false;
                        configViewTableResult();
                    }
                }
            });
        });

        if (mien == 'Xổ số Miền Bắc' || mien == 11) {
            $.getJSON(base_ur+'/jsons/' + id_ketqua + '_madb.json?t=' + date.getTime(), function(data) {
                $.each(data, function(k, v) {
                    if($('#mad_db_' + id_ketqua)){
                        $('#mad_db_' + id_ketqua).html(data.ma_1ty);
                    }else{
                        $('.js-ma-db-' + id_ketqua).html(data.ma_1ty);
                    }
                });
            });
        }
    }

    function refreshPage() {
        var date = new Date();

        var hour = date.getHours();
        var minutes = date.getMinutes();
        var day = date.getDay();
        var month = date.getMonth();

        var _day = date.getDate();
        var _month = month + 1;
        var year = date.getFullYear();

        if($('.js-load-more-tinh').length === 0 
        && $('.js-load-more-mien-nam').length === 0 
        && $('.js-load-more-mien-trung').length === 0 
        && $('.js-load-more-mien-bac').length === 0) return;

        if (hour < 18) {
            $('.js-load-more-tinh').each(function(index, el) {
                if (jBody.hasClass('page-template-quay-thu-kqxs')) return;
                var _self = $(this);

                if (_self.hasClass('complete')) {
                    configViewTableResult();
                    return;
                }

                if (!jBody.hasClass('post')) {
                    if (!_self.hasClass('dont-hide')) {
                        _self.addClass('hidden');
                    }
                }
            });

            $('.js-load-more-mien-nam').each(function(index, el) {
                if (jBody.hasClass('page-template-quay-thu-kqxs')) return;
                if (index == 1) return;

                var _self = $(this);
                if (!_self.hasClass('dont-hide')) {
                    _self.addClass('hidden');
                }
            });

            $('.js-load-more-mien-trung').each(function(index, el) {
                if (jBody.hasClass('page-template-quay-thu-kqxs')) return;
                if (index == 1) return;

                var _self = $(this);
                if (!_self.hasClass('dont-hide')) {
                    _self.addClass('hidden');
                }
            });

            $('.js-load-more-mien-bac').each(function(index, el) {
                if (jBody.hasClass('page-template-quay-thu-kqxs')) return;
                if (index == 1) return;

                var _self = $(this);
                if (!_self.hasClass('dont-hide')) {
                    _self.addClass('hidden');
                }
            });
        }

        if (hour >= 16 && hour <= 18) {
            $('.js-live-message').addClass('hidden');
            if (!$('.js-live-message-mien-nam').hasClass('done')) {
                $('.js-live-message-mien-nam').removeClass('hidden');
                $('.js-live-message-box-kq-xsmn').removeClass('hidden');
            }
            if (hour >= 17 && hour <= 18) {
                $('.js-live-message').addClass('hidden');
                if (!$('.js-live-message-mien-trung').hasClass('done')) {
                    $('.js-live-message-mien-trung').removeClass('hidden');
                    $('.js-live-message-box-kq-xsmt').removeClass('hidden');
                }
            }
            if (hour >= 18 && hour <= 19) {
                $('.js-live-message').addClass('hidden');
                if (!$('.js-live-message-mien-bac').hasClass('done')) {
                    $('.js-live-message-mien-bac').removeClass('hidden');
                    $('.js-live-message-box-kq-xsmb').removeClass('hidden');
                }
            }
            /*
			$.getJSON('https://atrungroi.com/jsons/mn-'+_day+'-'+_month+'-'+year+'.json?t=' + date.getTime(), function(data) {
				if(data.has_result){
					$('.js-live-message-mien-nam').addClass('hidden done');
				}				
			});
			*/

            if (hour > 16 || (hour == 16 && minutes > 40)) {
                $('.js-live-message').addClass('hidden');
                $('.js-live-message-box-kq-xsmn').addClass('hidden');
            }

            // load more tinh
            $('.js-load-more-tinh').each(function(index, el) {
                var id_ketqua = $(el).attr('data-ketqua-id');
                var _self = $(this);
                if (_self.hasClass('complete')) {
                    _self.find('.alert').remove();
                    configViewTableResult();
                    return;
                }

                _self.removeClass('hidden');

                if (_self.find('.js-loading-number').length == 0) {
                    _self.find('.alert').remove();
                    _self.addClass('complete');
                }
                getResult(id_ketqua, _self.attr('data-mien'));

            });

            $('.js-load-more-mien-nam').each(function(index, el) {
                if (jBody.hasClass('page-template-quay-thu-kqxs')) return;

                var _self = $(this);
                _self.removeClass('hidden');

                if (_self.hasClass('complete')) {
                    configViewTableResult();
                    return;
                }

                var data_ketqua = $(el).attr('data-ketqua');
                var ketquas = data_ketqua.split(',');
                $(el).find('.js-loading-number').removeClass('next');
                for (var i = 0; i < ketquas.length; i++) {
                    getResult(ketquas[i], 2);
                }

                if (_self.find('.js-loading-number').length == 0) {
                    _self.find('.alert').remove();
                    _self.addClass('complete');
                    configViewTableResult();
                    $('.js-live-message').addClass('hidden');
                    $('.js-live-message-mien-nam').removeClass('hidden');
                    $('.js-live-message-box-kq-xsmn').removeClass('hidden');
                }
            });

            $('.home .js-table-mien-nam').each(function(index, el) {
                var has_data = true;
                if (index == 0 && $(el).hasClass('complete')) {
                    has_data = false;
                }

                if (has_data && index == 1) {
                    $(el).remove();
                }
            });

            if (hour >= 17 && hour <= 18) {
                $('.js-live-message').addClass('hidden');
                if (!$('.js-live-message-mien-trung').hasClass('done')) {
                    $('.js-live-message-mien-trung').removeClass('hidden');
                    $('.js-live-message-box-kq-xsmt').removeClass('hidden');
                }
                /*
				$.getJSON('https://atrungroi.com/jsons/mt-'+_day+'-'+_month+'-'+year+'.json?t=' + date.getTime(), function(data) {
					if(data.has_result){
						$('.js-live-message-mien-trung').addClass('hidden done');
					}				
				});
				*/

                if (hour > 17 || (hour == 17 && minutes > 40)) {
                    $('.js-live-message-mien-trung').addClass('hidden');
                    $('.js-live-message-box-kq-xsmt').addClass('hidden');
                }
                $('.js-load-more-mien-trung').each(function(index, el) {
                    if (jBody.hasClass('page-template-quay-thu-kqxs')) return;

                    var _self = $(this);
                    _self.removeClass('hidden');

                    if (_self.hasClass('complete')) {
                        configViewTableResult();
                        return;
                    }

                    var data_ketqua = $(el).attr('data-ketqua');
                    var ketquas = data_ketqua.split(',');
                    $(el).find('.js-loading-number').removeClass('next');
                    for (var i = 0; i < ketquas.length; i++) {
                        getResult(ketquas[i], 7);
                    }

                    if (_self.find('.js-loading-number').length == 0) {
                        _self.find('.alert').remove();
                        _self.addClass('complete');
                        configViewTableResult();
                        $('.js-live-message').addClass('hidden');
                        $('.js-live-message-mien-trung').removeClass('hidden');
                        $('.js-live-message-box-kq-xsmt').removeClass('hidden');
                    }
                });

                $('.home .js-table-mien-trung').each(function(index, el) {
                    var has_data = true;
                    if (index == 0 && $(el).hasClass('complete')){
                        has_data = false;
                    }
                    if (has_data && index == 1) {
                        $(el).remove();
                    }
                });
            }

            if (hour >= 18 && hour <= 19) {
                $('.js-live-message').addClass('hidden');
                if (!$('.js-live-message-mien-bac').hasClass('done')) {
                    $('.js-live-message-mien-bac').removeClass('hidden');
                    $('.js-live-message-box-kq-xsmb').removeClass('hidden');
                }

                /*
				$.getJSON('https://atrungroi.com/jsons/mb-'+_day+'-'+_month+'-'+year+'.json?t=' + date.getTime(), function(data) {
					if(data.has_result){
						$('.js-live-message-mien-bac').addClass('hidden done');
					}				
				});
				*/

                if (hour > 18 || (hour == 18 && minutes > 40)) {
                    $('.js-live-message-mien-bac').addClass('hidden done');
                    $('.js-live-message-box-kq-xsmb').addClass('hidden');
                }

                $('.js-load-more-mien-bac').each(function(index, el) {
                    // bỏ qua phần quay thử
                    if (jBody.hasClass('page-template-quay-thu-kqxs')) return;

                    var _self = $(this);
                    _self.removeClass('hidden');

                    if (_self.hasClass('complete')) {
                        configViewTableResult();
                        return;
                    }
                    var data_ketqua = $(el).attr('data-ketqua');
                    var ketquas = data_ketqua.split(',');
                    $(el).find('.js-loading-number').removeClass('next');
                    for (var i = 0; i < ketquas.length; i++) {
                        getResult(ketquas[i], 11); //
                    }

                    if (_self.find('.js-loading-number').length == 0) {
                        _self.addClass('complete');
                        _self.find('.alert').remove();
                        configViewTableResult();
                        $('.js-live-message').addClass('hidden');
                        $('.js-live-message-mien-bac').removeClass('hidden');
                        $('.js-live-message-box-kq-xsmb').removeClass('hidden');
                    }
                });

                $('.home .js-table-mien-bac').each(function(index, el) {
                    var has_data = true;
                    if (index == 0 && $(el).hasClass('complete')) {
                        has_data = false;
                    }
                    if (has_data && index == 1) {
                        $(el).remove();
                    }
                });
            }
        
            setTimeout(function() {
                refreshPage();
            }, 10 * 1000);
        }
    }

    function reloadData() {
        var date = new Date();

        var hour = date.getHours();
        var minutes = date.getMinutes();
        var day = date.getDay();
        var dayofmonth = date.getDate();
        var month = date.getMonth();

        if (hour >= 17 && hour < 18) {
            $('.js-result-number-power').each(function(index, el) {
                $(el).closest('.js-result-power-wrap').find('.js_result_comingsoon').removeClass('hidden');
            });
        }

        if (hour >= 18 && hour < 20 && (day == 2 || day == 4 || day == 6)) {

            $('.js-result-number-power').each(function(index, el) {
                // mặc định thì ẩn
                //$(el).closest('.js-result-power-wrap').find('.js_result_comingsoon').addClass('hidden');
                if ($(el).hasClass('complete')) {
                    $(el).closest('.js-result-power-wrap').find('.js_result_comingsoon').addClass('hidden');
                    //return;
                }

                if (day != 2 && day != 4 && day != 6) {
                    $(el).closest('.js-result-power-wrap').find('.js_result_comingsoon').addClass('hidden');
                    return;
                }

                var power_id = $(el).attr('data-power');
                if (typeof power_id === 'undefined') return;

                $.getJSON(base_url+'power_jsons/power_' + power_id + '.json?t=' + date.getTime(), function(data) {
                    $.each(data, function(k, v) {
                        //$('#mad_db_'+id_ketqua).html(data.ma_1ty);

                        var numbers = data.numbers;
                        var html_number = '';
                        numbers.forEach(function(number, index) {
                            var _number = number.number != '' ? number.number : '?';
                            if (number.ordering == 7) {
                                if (_number == '?' || _number == 0) {
                                    if(hour >= 18){
                                        $('.js-result-number-power .js-loading-number').addClass('next');
                                    }
                                    // if (hour >= 18) {
                                    //     html_number +=
                                    //         '<span class='ball big green js-loading-number next loading' data-id-giai='9'>?</span>';
                                    // } else {
                                    //     html_number +=
                                    //         '<span class='ball big green me-0'>
                                    //             <div class='spinner-border spinner-border-sm text-light' style='--bs-spinner-border-width: 0.2rem;'></div>
                                    //         </span>';
                                    // }

                                    $(el).closest('.js-result-power-wrap').find('.js_result_comingsoon').removeClass('hidden');
                                    if (hour >= 18) {
                                        $(el).closest('.js-result-power-wrap').find('.js_result_comingsoon span').html(
                                            'Đang trực tiếp từ trường quay, kết quả sẽ được cập nhật tự động bên dưới'
                                        );
                                    } else {
                                        $(el).closest('.js-result-power-wrap').find('.js_result_comingsoon span').html(
                                            'Chưa tới giờ quay số, kết quả sẽ được cập nhật tự động bên dưới'
                                        );
                                    }
                                } else {
                                    $(el).closest('.js-result-power-wrap').find('.js_result_comingsoon').addClass('hidden');
                                    $(el).addClass('has-number');

                                    if (_number < 10) {
                                        _number = '0' + parseInt(_number);
                                    }
                                    // html_number += '<span class='ball big green'>' + _number + '</span>';
                                    // $('.js-number-power-'+number.id).html(_number);
                                    $('.js-number-power-'+number.id).html(_number).removeClass('js-loading-number next');
                                }
                            } else {
                                if (_number == '?' || _number == 0) {
                                    if(hour >= 18){
                                        $('.js-result-number-power .js-loading-number').addClass('next');
                                    }
                                    // if (hour >= 18) {
                                    //     html_number +=
                                    //         '<span class='ball big yellow js-loading-number next loading' data-id-giai='9'>?</span>';
                                    // } else {
                                    //     html_number +=
                                    //         '<span class='ball big yellow' data-id-giai='9'>?</span>';
                                    // }
                                } else {
                                    if (_number < 10) {
                                        _number = '0' + parseInt(_number);
                                    }
                                    // html_number +=
                                    //     '<span class='ball big yellow'>' + _number + '</span>';
                                    $('.js-number-power-'+number.id).html(_number).removeClass('js-loading-number next');
                                }
                            }
                        });

                        // $(el).find('.js-result-number').html(html_number);

                        var giaithuongs = data.giaithuong;
                        var html_giaithuong = '';
                        var jackpot_1 = 'Ước tính 30 tỷ đồng';
                        var jackpot_2 = 'Ước tính 3 tỷ đồng';
                        giaithuongs.forEach(function(giai_thuong, index) {

                            if (index == 0) {
                                jackpot_1 = giai_thuong.gia_tri;
                                if (giai_thuong.chenh_lech !== '') {
                                    $('.js-tang-them').removeClass('hidden').html(giai_thuong.chenh_lech);
                                }
                                if (giai_thuong.so_luong > 0) {
                                    $('.js-result-power-wrap').find('.js-vietlott-item-content').addClass('win-jackpot');
                                }

                                if(!isNaN(giai_thuong.so_luong)){
                                    $('.js_power_jackpot_1_sl').html(giai_thuong.so_luong);
                                }
                            }
                            if (index == 1) {
                                jackpot_2 = giai_thuong.gia_tri;
                                if (giai_thuong.so_luong > 0) {
                                    $('.js-result-power-wrap').find('.js-vietlott-item-content').addClass('win-jackpot');
                                }
                                if(!isNaN(giai_thuong.so_luong)){
                                    $('.js_power_jackpot_2_sl').html(giai_thuong.so_luong);
                                }
                            }
                            if (index == 2 && !isNaN(giai_thuong.so_luong)) {
                                $(el).closest('.js-result-power-wrap').find('.js_power_giai_1').html(giai_thuong.so_luong);
                            }
                            if (index == 3 && !isNaN(giai_thuong.so_luong)) {
                                $(el).closest('.js-result-power-wrap').find('.js_power_giai_2').html(giai_thuong.so_luong);
                            }
                            if (index == 4 && !isNaN(giai_thuong.so_luong)) {
                                $(el).closest('.js-result-power-wrap').find('.js_power_giai_3').html(giai_thuong.so_luong);
                            }

                            if (index == 4 && giai_thuong.so_luong != 'Đang cập nhật...') {
                                $(el).addClass('complete');
                            }
                        });

                        // $(el).closest('.js-result-power-wrap').find('.js_power_jackpot1').html(jackpot_1);
                        $('.js_power_jackpot1').html(jackpot_1);
                        $('.js_power_jackpot2').html(jackpot_2);
                    });

                    generateNumber();
                });
            });
            // setTimeout(function() {
            //     reloadData();
            // }, 10 * 1000);
        }

        if (hour >= 18 && hour < 20 && (day == 1 || day == 3 || day == 5)) {
            $('.js-max3d-result-body').each(function(index, el) {
                if ($(el).hasClass('complete')) return;

                var max3d_id = $(el).attr('data-id');
                //if(typeof max4d_id === 'undefined') return;
                var number_giai_nhat = '';
                $.getJSON(base_url+'max3d_jsons/' + max3d_id + '.json?t=' +date.getTime(), function(data) {
                    $.each(data, function(k, v) {
                        if (v.length > 0) {
                            if($(el).find('.' + k).length){
                                $(el).find('.' + k).html(v);
                            }else{
                                $(el).find('#' + k).html(v);
                            }
                        }
                    });
                });
            });

            // setTimeout(function() {
            //     reloadData();
            // }, 10 * 1000);
        }

        if (hour >= 18 && hour < 20 && (day == 2 || day == 4 || day == 6)) {
            $('.js-max3d-pro-result').each(function(index, el) {
                if ($(el).hasClass('complete')) return;

                var max3d_pro_id = $(el).attr('data-max3d-pro-id');
                $.getJSON(base_url+'max3d_pro_jsons/' + max3d_pro_id + '.json?t=' + date.getTime(), function(data) {
                    $.each(data, function(k, v) {
                        if (v.length > 0) {
                            // $(el).find('#' + k).html(v);
                            if($(el).find('.' + k).length){
                                $(el).find('.' + k).html(v);
                            }else{
                                $(el).find('#' + k).html(v);
                            }
                        }
                    });
                });
            });

            // setTimeout(function() {
            //     reloadData();
            // }, 10 * 1000);
        }
        //testing
        if (hour >= 18 && hour < 20 && (day == 0 || day == 3 || day == 5)) {
            $('.js-result-number-mega').each(function(index, el) {
                if ($(el).hasClass('complete')) {
                    $(el).closest('.js-result-mega-wrap').find('.js_result_comingsoon').addClass('hidden');
                    return;
                }

                var mega_id = $(el).attr('data-mega');

                $.getJSON(base_url+'mega_jsons/' + mega_id + '.json?t=' + date.getTime(), function(data) {
                    $.each(data, function(k, v) {
                        var numbers = data.numbers;
                        var html_number = '';
                        numbers.forEach(function(number, index) {
                            var _number = number.number != '' ? number.number : '?';

                            if (_number == '?' || _number == 0) {
                                if(hour >= 18){
                                    $('.js-result-number-mega .js-loading-number').addClass('next');
                                }
                                // if (hour >= 18) {
                                //     html_number +=
                                //         '<span class='ball big red js-loading-number next loading' data-id-giai='9'>?</span>';
                                // } else {
                                //     html_number += '<span class='ball big ms-0 me-2 js-number-mega' data-position='0'><div class='spinner-border spinner-border-sm text-light' style='--bs-spinner-border-width: 0.2rem;'></div></span>';
                                // }
                            } else {
                                if (_number < 10) {
                                    _number = '0' + parseInt(_number);
                                }
                                // html_number +='<span class='ball big red'>' + _number + '</span>';
                                $('.js-number-mega-'+number.id).html(_number).removeClass('js-loading-number next');
                            }
                            if (number.ordering == 6 && ( _number == '?' || _number == 0)) {
                                $(el).addClass('has-number');
                            }
                            if (number.ordering == 6 && ( _number == '?' || _number == 0) && minutes >= 27) {
                                //if(index == 5 && _number != '?'){
                                // $(el).addClass('complete');
                            }
                            if (number.ordering == 6 && ( _number == '?' || _number == 0)) {
                                $(el).closest('.js-result-mega-wrap').find('.js_result_comingsoon').removeClass('hidden');
                                $(el).closest('.js-result-mega-wrap').find('.js_result_comingsoon span').html(
                                    'Đang trực tiếp từ trường quay, kết quả sẽ được cập nhật tự động bên dưới'
                                );
                            }
                        });
                        // $(el).find('.js-result-number').html(html_number);
                    });
                    generateNumber();

                    // giải thưởng
                    var giai_thuongs = data.giaithuongs;
                    if (giai_thuongs[0] && giai_thuongs[0].so_luong != '') {
                        $('.js-giatri-jackpot').html(giai_thuongs[0].gia_tri);
                        $('.js-soluong-jackpot').html(giai_thuongs[0].so_luong);
                        if (giai_thuongs[0].chenh_lech !== '') {
                            $('.js-tang-them').removeClass('hidden').html(giai_thuongs[0].chenh_lech);
                        }else{
                            $('.js-tang-them').addClass('hidden');
                        }

                        if (giai_thuongs[0].so_luong > 0) {
                            $('.js-result-mega-wrap').find('.js-vietlott-item-content').addClass('win-jackpot');
                        }
                    }
                    if (giai_thuongs[1] && giai_thuongs[1].so_luong != '') {
                        $('.js-soluong-giai-1').html(giai_thuongs[1].so_luong);
                    }
                    if (giai_thuongs[2] && giai_thuongs[2].so_luong != '') {
                        $('.js-soluong-giai-2').html(giai_thuongs[2].so_luong);
                    }
                    if (giai_thuongs[3] && giai_thuongs[3].so_luong != '') {
                        $('.js-soluong-giai-3').html(giai_thuongs[3].so_luong);
                    }
                });
            });

            // setTimeout(function() {
            //     reloadData();
            // }, 10 * 1000);
        }

        if (hour >= 6 && hour <= 21) {

            var time_keno = 8;
            var latest_keno_item = false;
            // if(month == 3 && dayofmonth <=22) return;
            if($('.js-keno-result-box').length){

                if($('.js-keno-latest').length){
                    latest_keno_item = $('.js-keno-latest');
                }else{
                    latest_keno_item = $('.js-wrap-content-kenos .js-keno-item').first();
                }
                var keno_today = date.getFullYear() + '-' + pad(date.getMonth() + 1, 2) + '-' + pad(date.getDate(), 2);
                var next_ky_quay = parseInt(latest_keno_item.attr('data-kyquay')) + 1;
                var latest_gio_so = latest_keno_item.attr('data-time');

                var last_minutes = latest_gio_so.split(':');
                var next_minute = parseInt(last_minutes[1])+time_keno;
                var next_hour = parseInt(last_minutes[0]);
                if (next_minute >= 60) {
                    next_minute = next_minute%60;
                    next_hour = hour + 1;
                }

                $('.js-keno-item-next').attr('data-kyquay', next_ky_quay);
                $('.js-keno-item-next').find('.js-ky-tiep-theo').html('#' + next_ky_quay);
                $('.js-keno-item-next').attr('data-time', pad(next_hour, 2) + ':' + pad(next_minute, 2));
                $('.js-keno-item-next').find('.js-data-full-time').html(
                    pad(next_hour, 2) + ':' + pad(next_minute, 2) + ' ' + pad(date.getDate(), 2) + '/' + pad(date.getMonth() + 1, 2) + '/' + date.getFullYear() 
                );
                var keno_reload_next = $('.js-keno-item-next').clone();

                if(!keno_current_done){
                    $('.js-keno_result-numbers').find('.js-time-result').countdown(
                        // date.getFullYear() + '/' + pad(date.getMonth() + 1, 2) + '/' + pad(date.getDate(), 2) + ' ' + pad(next_hour, 2) + ':' + pad(next_minute + 1, 2) + ':00'
                        date.getFullYear() + '/' + pad(date.getMonth() + 1, 2) + '/' + pad(date.getDate(), 2) + ' ' + pad(next_hour, 2) + ':' + pad(next_minute + 1, 2) + ':00'
                    ).on('update.countdown', function(event) {
                        var format = '%M:%S';
                        $(this).html(event.strftime(format));
                    }).on('finish.countdown', function(event) {
                        $('.js-keno-item-next').removeClass('hidden');
                        $('.js-keno_result-numbers').find('.js-time-result').html('0'+time_keno+':00');

                        $('.js-keno-latest').prependTo('.js-wrap-content-kenos').removeClass('js-keno-latest');
                        // window.location.reload();
                    });
                }
                
                $.getJSON('/keno_jsons/' + keno_today + '.json?t=' + date.getTime(), function(data) {
                    $.each(data, function(k, v) {
                        keno_current_done = false;
                        if (k == next_ky_quay) {
                            var _html_number = '';
                            var numbers = [];
                            $.each(v.numbers, function(_i, _v) {
                                if (!isNaN(_v.number)) {
                                    _html_number += '<div class="w-10 p-1"><div class="ball keno">' + pad(_v.number, 2) + '</div></div>';
                                    numbers.push(_v.$_number);
                                } else {
                                    _html_number += '<div class="w-10 p-1 js-loading-number"><div class="ball keno m-0"><div class="spinner-border spinner-border-sm text-body fs-6" role="status"></div></div></div>';
                                }
                            });
                            
                            // notification_sound.play();
                            keno_reload_next.find('.js_keno__numbers').html(_html_number);

                            if (v.done) {
                                // xu ly chan le
                                var chan = le = lon = nho = 0;
                                $.each(v.numbers, function(_i, _v) {
                                    if (!isNaN(_v.number)) {
                                        if(parseInt(_v.number)%2 == 0){
                                            chan++;
                                        }else{
                                            le++;
                                        }
                                        if(parseInt(_v.number) > 40){
                                            lon++;
                                        }else{
                                            nho++;
                                        }
                                    }
                                });
                                next_minute = next_minute + time_keno;
                                next_hour = hour;
                                if (next_minute >= 60) {
                                    next_minute = next_minute%60;
                                    next_hour = hour + 1;
                                }
                                next_next_time = pad(next_hour, 2) + ':' + pad(next_minute, 2) + ' '+ pad(date.getDate(), 2) + '/' + pad(date.getMonth() + 1, 2) + '/' + date.getFullYear();
                                next_ky_quay = parseInt(k) + 1;

                                keno_reload_next.removeClass('js-keno-item-next hidden').addClass('done');
                                keno_reload_next.find('.js-keno-chan').html(chan);
                                keno_reload_next.find('.js-keno-le').html(le);
                                keno_reload_next.find('.js-keno-lon').html(lon);
                                keno_reload_next.find('.js-keno-nho').html(nho);
                                keno_reload_next.prependTo('.js-wrap-content-keno-latest').addClass('js-keno-latest');

                                // reload thong ke
                                getThongkeKeno();
                                keno_current_done = true;

                                $('.js-keno-item-next').attr('data-kyquay', next_ky_quay);
                                $('.js-keno-item-next').find('.js-ky-tiep-theo').html('#'+ (next_ky_quay));
                                $('.js-keno-item-next').find('.js-data-full-time').html(next_next_time);
                                $('.js-keno-item-next').attr('data-time', pad(next_hour, 2) + ':' + pad(next_minute, 2));
                                $('.js-keno-item-next').addClass('hidden');

                                window.location.reload();
                            }
                        }
                    });
                }).fail(function() { 
                    $('.js-keno-item-next').remove();
                });
            
                setTimeout(function() {
                    reloadData();
                }, 10 * 1000);
            }

        }

        if(hour >= 16 && hour <= 20){
            var second = 10;
            // if (hour < 18) {
            //     second = 10;
            // }
            setTimeout(function() {
                reloadData();
            }, 10 * 1000);
        }


        if($('.js-count-down-wrap').length){
            var time = $('.js-count-down-wrap').find('.js-time-result').attr('data-time');
            $('.js-count-down-wrap').find('.js-time-result')
                .countdown(date.getFullYear() + '/' +pad(date.getMonth() + 1, 2) + '/' + pad(date.getDate(), 2) + ' ' + time)
                .on('update.countdown', function(event) {
                    var format = '%H:%M:%S';
                    $(this).html(event.strftime(format));
                })
                .on('finish.countdown', function(event) {
                    $('.js-count-down-wrap').remove();
                })
                .on('stop.countdown', function(event) {
                    $('.js-count-down-wrap').remove();
                });
        }
    }

    function getThongkeKeno() {
        $.ajax({
            url: base_api_url+'get/thongke/kenos',
            method: 'post',
            type: 'json',
            success: function(res) {
                if (res.success) {
                    if (res.html != '') {
                        $('.js-thong-ke-box').html(html);
                    }
                }
            }
        });
    }

    function configViewTableResult() {
        
        // init đầu đuôi
        // console.log('init dau dauoi');
        $('.js-number-dau-duoi').each(function(index, ele) {
            var _self = $(ele);
            var page_id = _self.attr('data-page-id');
            var number_hl = _self.attr('data-num');
            var date = new Date();
            var hour = date.getHours();

            var find_position = 0;
            var find_num_position = _self.attr('data-find') ?
                _self.attr('data-find') : 'dau';
            if (find_num_position == 'duoi') {
                find_position = 1;
            }

            var js_table_result = _self.closest('.js-table-result');

            var find_number_matched = '';
            js_table_result.find('.number').each(function(index, el) {
                if ($(el).hasClass('js-loading-number')) return;

                if ($(el).attr('data-page-id') == page_id) {
                    var _number = $(el).attr('data-num');
                    if (_number && _number.length >= 2) {
                        // lấy ra 2 kí tự
                        var _number_will_hl = _number.slice(-2);
                        // kiểm tra xem có số cần tìm ko
                        if (_number_will_hl.indexOf(number_hl) > -1) {
                            // nếu có số cần tìm thì số đó phải ở hàng chục
                            var _find_number_position = _number_will_hl.indexOf(number_hl);
                            if (find_num_position == 'duoi') {
                                _find_number_position = 1 - _find_number_position;
                            }

                            if (
                                _number_will_hl.indexOf(number_hl) == find_position ||
                                _number_will_hl.slice(0, 1) == _number_will_hl.slice(-1)
                            ) {
                                // var _number_will_hl_show = _number_will_hl.slice(-1);
                                // if (find_position == 1) {
                                //     _number_will_hl_show = _number_will_hl.slice(0, 1);
                                // }
                                // if (find_number_matched == '') {
                                //     find_number_matched +=
                                //         '<span class="number-dau-duoi js-highlight" data-highlight-number="' +_number_will_hl +'">' +_number_will_hl_show +"</span>";
                                // } else {
                                //     find_number_matched +=
                                //         ', <span class="number-dau-duoi js-highlight" data-highlight-number="' +_number_will_hl +'">' +_number_will_hl_show +"</span>";
                                // }
                                if (find_number_matched == '') {
                                    find_number_matched += _number_will_hl;
                                } else {
                                    find_number_matched += ', '+_number_will_hl;
                                }
                            }
                        }
                    }
                }
            });

            // update vào html
            _self.html('');
            if (hour > 16 || find_number_matched != '' ||js_table_result.find('.js-highlight').length > 0) {
                _self.html(find_number_matched);
            }
        });

        $('.js-config-view input[name="show_number"]').on('click', function() {
            var _self = $(this);
            var total_show_number = _self.val();

            if (total_show_number == -1) {
                resetTableResult(_self.closest('.js-result-wrap').find('.js-table-result'));
            } else {
                showTableResult(_self.closest('.js-result-wrap').find('.js-table-result'), total_show_number);
            }
        });
    }

    function resetTableResult($ele) {
        $ele.find('.number').each(function(index, el) {
            if($(el).attr('data-num-special')){
                $(el).html($(el).attr('data-num-special'));
            }else{
                if ($(el).attr('data-num')) {
                    // $(el).html($(el).attr('data-num'));
                    var _number = $(el).attr('data-num');
                    $(el).html(_number.substr(0, _number.length-2)+'<span class="text-red">'+_number.slice(-2)+'</span>');
                }
            }
        });
    }

    function showTableResult($ele, total_show_number) {
        total_show_number = total_show_number || 2;
        if(total_show_number == 2 || total_show_number == 3){
            $ele.find('.number').each(function(index, el) {
                // if ($(el).hasClass('js-loading-number')) return;
                var _number = $(el).attr('data-num');
                if (_number && _number.length >= total_show_number) {
                    $(el).html('<span class="text-red">'+_number.slice(-total_show_number)+'</span>');
                }
            });
        }
        if(total_show_number == 4){
            $ele.find('.number').each(function(index, el) {
                // if ($(el).hasClass('js-loading-number')) return;
                var _number = $(el).attr('data-num');
                if (_number && _number.length) {
                    $(el).html('<span class="text-red">'+_number.substr(-1, 1)+'</span>');
                }
            });
        }
        if(total_show_number == 5){
            $ele.find('.number').each(function(index, el) {
                // if ($(el).hasClass('js-loading-number')) return;
                var _number = $(el).attr('data-num');
                if (_number && _number.length) {
                    $(el).html('<span class="text-red">'+_number.substr(-2, 1)+'</span>');
                }
            });
        }
        if(total_show_number == 6){
            $ele.find('.number').each(function(index, el) {
                // if ($(el).hasClass('js-loading-number')) return;
                var _number = $(el).attr('data-num');
                if (_number && _number.length) {
                    $(el).html('<span class="text-red">'+(parseInt(_number.substr(-1, 1)) + parseInt(_number.substr(-2, 1))) +'</span>');
                }
            });
        }
    }

    function quayThuKqxs() {
        var number_quay_timout = false;
        var gen_number_quay_timout = false;

        var clone_html = $('.js-table-quay-thu-live .js-kq-table').html();
        $('.js-option-quay-thu').on('click', function() {
            var _self = $(this);
            var _option = _self.val();

            var date = new Date();
            var _day = date.getDate();
            var _month = date.getMonth() + 1;
            var year = date.getFullYear();
            var day = _day + '/' + _month + '/' + year;

            if (_option == 'quaythu_tinh') {
                $.ajax({
                    url: atrungroi_ajax.ajaxurl,
                    data: {
                        action: 'load_all_province',
                        ngay: day,
                        truyenthong: 1
                    },
                    type: 'post',
                    success: function(data) {
                        if (data.success) {
                            $('.js-quay-thu-province').html(data.data.html);
                        }
                    }
                });
            } else {
                var html_mien =
                    '<option value="">Chọn Miền</option>' +
                    '<option value="mien-bac">Miền Bắc</option>' +
                    '<option value="mien-nam">Miền Nam</option>' +
                    '<option value="mien-trung">Miền Trung</option>';

                $('.js-quay-thu-province').html(html_mien);
            }
        });

        $('.js-btn-quay-thu-detail').on('click', function(event) {
            event.preventDefault();
            var quaythu_type = $('.js-select-type-quay-thu').val();
            if(quaythu_type == 'birthday'){
                var _day = $('.js-select-ngay-sinh').val() || '';
                var _month = $('.js-select-thang-sinh').val() || '';
                var _year = $('.js-select-nam-sinh').val() || '';
                // swal({
                //     title: 'Thông báo',
                //     text: 'Bạn chưa chọn ngày sinh',
                //     type: 'error',
                //     timer: 3000,
                //     showConfirmButton: false
                // }).catch(swal.noop);
                if(_day == '' || _month == '' || _year == ''){
                    alert('Bạn chưa chọn ngày sinh');
                    return;
                }
            }
            var _self = $(this);
            var button_text = _self.html();

            // if (_self.hasClass('da-quay-thu')) {
            //     $('html, body').animate({
            //         scrollTop: 0
            //     }, 'fast');
            //     window.location.reload();
            // }
            $('.js-btn-quay-thu-nhanh').removeClass('disabled');
            if($('.js-btn-quay-thu-nhanh').hasClass('da-quay-thu')){
                $('.js-btn-quay-thu-nhanh').removeClass('da-quay-thu');
                $('.js-btn-quay-thu-nhanh').html('Quay nhanh');
            }

            clearTimeout(quaythutimeout);
            clearTimeout(number_quay_timout);
            clearTimeout(gen_number_quay_timout);

            _self.html('Quay thử');
            _self.removeClass('da-quay-thu');
            
            $('.js-table-quay-thu-live .js-kq-table').html('');
            $('.js-table-quay-thu-live .js-kq-table').html(clone_html);
            

            $(this).addClass('disabled');
            _self.html('Đang quay...');
            _self.addClass('da-quay-thu');

            $('html, body').animate({
                scrollTop: _self.offset().top
            }, 1000);

            $('.js-table-quay-thu-live .js-kq-table .number').each(function(k, el) {
                $(el).html(
                    '<div class="spinner-border spinner-border-sm text-warning fs-6" role="status"></div>'
                );
                $(el).addClass('loading js-loading-number');
                $(el).attr('data-num', '');
                $(el).removeAttr('has-animate');
            });

            var data_quay = _self.attr('data-quay');
            var is_tinh = data_quay == 'tinh' ? true : false;

            $('.js-table-quay-thu-live').removeClass('complete');

            _quayThu(_self, is_tinh, 2000, 1500, 'Quay thử');
            ga('send', 'event', 'Quay thử '+data_quay, 'Click', 'Quay thử '+data_quay, 'quay thuong');
        });

        $('.js-btn-quay-thu-nhanh').on('click', function(event) {
            event.preventDefault();
            var quaythu_type = $('.js-select-type-quay-thu').val();
            if(quaythu_type == 'birthday'){
                var _day = $('.js-select-ngay-sinh').val() || '';
                var _month = $('.js-select-thang-sinh').val() || '';
                var _year = $('.js-select-nam-sinh').val() || '';
                // swal({
                //     title: 'Thông báo',
                //     text: 'Bạn chưa chọn ngày sinh',
                //     type: 'error',
                //     timer: 3000,
                //     showConfirmButton: false
                // }).catch(swal.noop);
                if(_day == '' || _month == '' || _year == ''){
                    alert('Bạn chưa chọn ngày sinh');
                    return;
                }
            }
            var _self = $(this);
            // if (_self.hasClass('da-quay-thu')) {
            //     $('html, body').animate({
            //         scrollTop: 0
            //     }, 'fast');
            //     window.location.reload();
            // }

            $('.js-btn-quay-thu-detail').removeClass('disabled');
            if($('.js-btn-quay-thu-detail').hasClass('da-quay-thu')){
                $('.js-btn-quay-thu-detail').removeClass('da-quay-thu');
                $('.js-btn-quay-thu-detail').html('Bắt đầu quay thử');
            }

            clearTimeout(quaythutimeout);
            clearTimeout(number_quay_timout);
            clearTimeout(gen_number_quay_timout);
            _self.html('Quay nhanh');
            _self.removeClass('da-quay-thu');
            
            $('.js-table-quay-thu-live .js-kq-table').html('');
            $('.js-table-quay-thu-live .js-kq-table').html(clone_html);


            $(this).addClass('disabled');
            _self.html('Đang quay...');
            _self.addClass('da-quay-thu');

            $('html, body').animate({
                scrollTop: _self.offset().top
            }, 1000);

            $('.js-table-quay-thu-live .js-kq-table .number').each(function(k, el) {
                $(el).html(
                    '<div class="spinner-border spinner-border-sm text-warning fs-6" role="status"></div>'
                );
                $(el).removeClass('next').addClass('loading js-loading-number');
                $(el).attr('data-num', '');
                $(el).removeAttr('has-animate');
            });

            var data_quay = _self.attr('data-quay');
            var is_tinh = data_quay == 'tinh' ? true : false;

            $('.js-table-quay-thu-live').removeClass('complete');

            _quayThu(_self, is_tinh, 400, 200, 'Quay nhanh');
            ga('send', 'event', 'Quay thử '+data_quay, 'Click', 'Quay thử '+data_quay, 'quay nhanh');
        });

        $('.js-btn-quay-thu').on('click', function(event) {
            event.preventDefault();

            var province = $('.js-quay-thu-province').val();
            $.ajax({
                url: atrungroi_ajax.ajaxurl,
                data: {
                    action: 'redirect_to_du_doan_page',
                    custom_page_id: province
                },
                type: 'post',
                success: function(data) {
                    if (data.success) {
                        window.location.href = data.data.link;
                    }
                }
            });
        });

        $('.js-quay-thu-province').on('change', function(event) {
            event.preventDefault();
            var province = $(this).val();
            $.ajax({
                url: atrungroi_ajax.ajaxurl,
                data: {
                    action: 'redirect_to_du_doan_page',
                    custom_page_id: province
                },
                type: 'post',
                success: function(data) {
                    if (data.success) {
                        window.location.href = data.data.link;
                    }
                }
            });
        });

        $('.js-select-type-quay-thu').on('change', function(){
            event.preventDefault();
            var _self = $(this);

            $('.js-btn-quay-thu-nhanh').removeClass('da-quay-thu disabled');
            $('.js-btn-quay-thu-nhanh').html('Quay nhanh');


            $('.js-btn-quay-thu-detail').removeClass('da-quay-thu disabled');
            $('.js-btn-quay-thu-detail').html('Bắt đầu quay thử');

            clearTimeout(quaythutimeout);
            clearTimeout(number_quay_timout);
            clearTimeout(gen_number_quay_timout);
            
            $('.js-table-quay-thu-live .js-kq-table').html('');
            $('.js-table-quay-thu-live .js-kq-table').html(clone_html);
            $('.js-table-quay-thu-live .js-kq-table .number').each(function(k, el) {
                $(el).html(
                    '<div class="spinner-border spinner-border-sm text-warning fs-6" role="status"></div>'
                );
                $(el).addClass('loading js-loading-number');
                $(el).attr('data-num', '');
                $(el).removeAttr('has-animate');
            });
            $('.js-table-quay-thu-live').removeClass('complete');

        });
    }

    function _quayThu($ele, tinh, time_out = 2000, time_between_province = 1500, button_text) {
        $ele = $ele || false;
        tinh = tinh || false;
        
        if ($('.js-table-quay-thu-live').hasClass('complete')) {
            $ele.removeClass('disabled');
            $ele.html(button_text);

            //$('.js-btn-quay-thu-detail').addClass('hidden');
            if ($ele) {
                $ele.removeClass('disabled');
                $ele.html(button_text);
            }

            $('.js-table-quay-thu-live .number').each(function(k, elx) {
                $(elx).attr('data-num', $(elx).html());
            });

            clearTimeout(quaythutimeout);
            clearTimeout(number_quay_timout);
            clearTimeout(gen_number_quay_timout);
            configViewTableResult();
            return;
        }

        var data_ketqua = $('.js-table-quay-thu-live').attr('data-ketqua') || $('.js-table-quay-thu-live').attr('data-ketqua-id');
        var ketquas = data_ketqua.split(',');

        $('.js-table-quay-thu-live').find('.js-loading-number').removeClass('next');

        var timeout = time_out;
        if (!tinh) {
            for (var i = 0; i < ketquas.length; i++) {
                // timeout += i * time_between_province - time_between_province;
                $('.js-table-quay-thu-live ' + '.' + ketquas[i] + '.number').each(function(k, el) {
                    number_quay_timout = setTimeout(function() {
                        $('.number').removeClass('next');
                        if (isNaN($(el).html())) {
                            $(el).addClass('next');
                        }

                        generateNumber();
                        gen_number_quay_timout = setTimeout(function() {
                            $id_giai = $(el).attr('data-id-giai');

                            var number = Math.floor(Math.random() * 99999) + 1;
                            $_number = pad(number, 5);
                            if ($id_giai == 9) {
                                number = Math.floor(Math.random() * 99) + 1;
                                $_number = pad(number, 2);
                            } else if ($id_giai == 8) {
                                number = Math.floor(Math.random() * 999) + 1;
                                $_number = pad(number, 3);
                            } else if ($id_giai == 7 || $id_giai == 6) {
                                number = Math.floor(Math.random() * 9999) + 1;
                                $_number = pad(number, 4);
                            } else if ($id_giai == 1) {
                                number = Math.floor(Math.random() * 999999) + 1;
                                $_number = pad(number, 6);
                            }

                            $(el).removeClass('loading');
                            $(el).removeClass('js-loading-number');
                            $(el).attr('data-num', $(el).html());

                            if (isNaN($(el).html()) && $(el).attr('data-id-giai') == $id_giai) {
                                $(el).html($_number);
                                $(el).attr('data-num', $_number);
                            }
                        }, timeout/2);
                    }, (k + 1) * timeout);
                });
            }
        } else {
            timeout = time_out;
            $('.js-table-quay-thu-live .number').each(function(k, xel) {
                number_quay_timout = setTimeout(function() {
                    $('.number').removeClass('next');
                    if (isNaN($(xel).html())) {
                        $(xel).addClass('next');
                    }

                    generateNumber();
                    gen_number_quay_timout = setTimeout(function() {
                        $id_giai = $(xel).attr('data-id-giai');

                        var number = Math.floor(Math.random() * 99999) + 1;
                        $_number = pad(number, 5);
                        if ($id_giai == 9) {
                            number = Math.floor(Math.random() * 99) + 1;
                            $_number = pad(number, 2);
                        } else if ($id_giai == 8) {
                            number = Math.floor(Math.random() * 999) + 1;
                            $_number = pad(number, 3);
                        } else if ($id_giai == 7 || $id_giai == 6) {
                            number = Math.floor(Math.random() * 9999) + 1;
                            $_number = pad(number, 4);
                        } else if ($id_giai == 1) {
                            number = Math.floor(Math.random() * 999999) + 1;
                            $_number = pad(number, 6);
                        }

                        $(xel).removeClass('loading');
                        $(xel).removeClass('js-loading-number');
                        $(xel).attr('data-num', $(xel).html());

                        if (isNaN($(xel).html()) && $(xel).attr('data-id-giai') == $id_giai) {
                            $(xel).html($_number);
                        }
                    }, timeout/2);
                }, (k + 1) * timeout);
            });
        }

        checkTableQuayThu($ele, button_text);
        
    }

    function checkTableQuayThu($ele, button_text){
        configViewTableResult();
        if ($('.js-table-quay-thu-live').find('.js-loading-number').length == 0) {  
            $('.js-table-quay-thu-live').addClass('complete');
            $ele.html('Đang thống kê đầu đuôi...');

            $ele.removeClass('disabled');
            $ele.html(button_text);

            $('.js-table-quay-thu-live .number').each(function(k, elx) {
                $(elx).attr('data-num', $(elx).html());
            });
            // configViewTableResult();
            clearTimeout(quaythutimeout);
            return;
        }

        quaythutimeout = setTimeout(function() {
            // _quayThu($ele, tinh);
            checkTableQuayThu($ele, button_text);
        }, 1000);
    }

    function filterTanSuat() {
        $('.js-get-table-tan-suat').each(function(index, el) {
            var mien_tinh = $(el).attr('data-mien-tinh');
            var kyquay = $(el).attr('data-kyquay');

            $.ajax({
                url: base_api_url+'get/thong-ke/tansuat',
                data: {
                    action: 'load_htm_thong_ke_tan_suat',
                    mien_tinh: mien_tinh,
                    ky_quay: kyquay
                },
                type: 'post',
                success: function(data) {
                    $('.preload').remove();
                    if (data.success) {
                        $(el).html(data.html);
                    }
                    $('.js-table-ngay-thang').removeClass('hidden');
                }
            });
        });

        $('.js-filter-chan-le').on('change', function() {
            var filter_chan_le = $(this).val();

            if (filter_chan_le != 'all') {
                $('.js-tan-suat-row').addClass('hidden');
                $('.js-number-row').addClass('hidden');

                $('.js-tan-suat-row').each(function(index, el) {
                    if ($(el).attr('data-type-num') == filter_chan_le) {
                        $(el).removeClass('hidden');
                    }
                });

                $('.js-number-row').each(function(index, el) {
                    if ($(el).attr('data-type-num') == filter_chan_le) {
                        $(el).removeClass('hidden');
                    }
                });
            } else {
                $('.js-tan-suat-row').removeClass('hidden');
                $('.js-number-row').removeClass('hidden');
            }
        });

        $('.js-filter-dau').on('change', function() {
            $('.js-filter-chan-le').val('all').trigger('change');

            var filter_dau = $(this).val();
            var filter_duoi = $('.js-filter-duoi').val();
            $('.js-tan-suat-row').addClass('hidden');
            $('.js-number-row').addClass('hidden');

            $('.js-tan-suat-row').each(function(index, el) {
                if (filter_dau == 'all' && filter_duoi == 'all') {
                    $(el).removeClass('hidden');
                }
                if (filter_duoi == 'all') {
                    if ($(el).attr('data-dau') == filter_dau) {
                        $(el).removeClass('hidden');
                    }
                } else if (filter_dau == 'all') {
                    if ($(el).attr('data-duoi') == filter_duoi) {
                        $(el).removeClass('hidden');
                    }
                } else {
                    if (
                        $(el).attr('data-dau') == filter_dau &&
                        $(el).attr('data-duoi') == filter_duoi
                    ) {
                        $(el).removeClass('hidden');
                    }
                }
            });

            $('.js-number-row').each(function(index, el) {
                if (filter_dau == 'all' && filter_duoi == 'all') {
                    $(el).removeClass('hidden');
                }
                if (filter_duoi == 'all') {
                    if ($(el).attr('data-dau') == filter_dau) {
                        $(el).removeClass('hidden');
                    }
                } else if (filter_dau == 'all') {
                    if ($(el).attr('data-duoi') == filter_duoi) {
                        $(el).removeClass('hidden');
                    }
                } else {
                    if (
                        $(el).attr('data-dau') == filter_dau &&
                        $(el).attr('data-duoi') == filter_duoi
                    ) {
                        $(el).removeClass('hidden');
                    }
                }
            });
        });

        $('.js-filter-duoi').on('change', function() {
            $('.js-filter-chan-le').val('all').trigger('change');
            var filter_duoi = $(this).val();
            var filter_dau = $('.js-filter-dau').val();
            $('.js-tan-suat-row').addClass('hidden');
            $('.js-number-row').addClass('hidden');

            $('.js-tan-suat-row').each(function(index, el) {
                if (filter_dau == 'all' && filter_duoi == 'all') {
                    $(el).removeClass('hidden');
                }

                if (filter_dau == 'all') {
                    if ($(el).attr('data-duoi') == filter_duoi) {
                        $(el).removeClass('hidden');
                    }
                } else if (filter_duoi == 'all') {
                    if ($(el).attr('data-dau') == filter_dau) {
                        $(el).removeClass('hidden');
                    }
                } else {
                    if (
                        $(el).attr('data-dau') == filter_dau &&
                        $(el).attr('data-duoi') == filter_duoi
                    ) {
                        $(el).removeClass('hidden');
                    }
                }
            });

            $('.js-number-row').each(function(index, el) {
                if (filter_dau == 'all' && filter_duoi == 'all') {
                    $(el).removeClass('hidden');
                }
                if (filter_dau == 'all') {
                    if ($(el).attr('data-duoi') == filter_duoi) {
                        $(el).removeClass('hidden');
                    }
                } else if (filter_duoi == 'all') {
                    if ($(el).attr('data-dau') == filter_dau) {
                        $(el).removeClass('hidden');
                    }
                } else {
                    if (
                        $(el).attr('data-dau') == filter_dau &&
                        $(el).attr('data-duoi') == filter_duoi
                    ) {
                        $(el).removeClass('hidden');
                    }
                }
            });
        });
    }

    function thongKeLotoXoSo() {
        $('.js-tk-number').on('click', function() {
            var number = $(this).html();
            var so_ky_quay = $(this).attr('data-kyquay');
            var mien_tinh = $(this).attr('data-mientinh');

            var link = thong_ke_loto_url + '?num=' + number + '&so_ky=' + so_ky_quay + '&mt=' + mien_tinh;
            window.open(link, '_blank');
        });
    }

    function quayThuPower() {
        $('.js-btn-quay-thu-power').on('click', function(e) {
            e.preventDefault();
            var _self = $(this);
            _self.html('Đang quay thử...');
            _self.addClass('disabled');

            if ($('.js-power-655-quaythu').hasClass('da-quay')) {
                $('.js-power-655-quaythu .js-num').each(function(k, el) {
                    $(el).addClass('loading');
                    $(el).addClass('js-loading-number');
                    $(el).removeAttr('has-animate');
                    $(el).html('?');
                });
            }

            var timeout = 1500;
            var results = [];
            $('.js-power-655-quaythu .js-num').each(function(k, el) {
                number_quay_timout = setTimeout(function() {
                    $('.js-num').removeClass('next');
                    if (isNaN($(el).html())) {
                        $(el).addClass('next');
                    }

                    generateNumber();
                    gen_number_quay_timout = setTimeout(function() {
                        var data_index = parseInt($(el).attr('data-index'));

                        var number = Math.floor(Math.random() * 55) + 1;
                        while (results.indexOf(number) != -1) {
                            number = Math.floor(Math.random() * 55) + 1;
                        }
                        if (data_index < 7) {
                            results.push(number);
                        }
                        $_number = pad(number, 2);

                        $(el).removeClass('loading');
                        $(el).removeClass('js-loading-number');

                        $(el).html($_number);

                        if (data_index == 7) {
                            results.sort(function(a, b) {
                                return a - b;
                            });

                            setTimeout(function() {
                                $('.js-power-655-quaythu .js-num').each(function(k, el) {
                                    if (k < 6) {
                                        $_number = pad(results[k], 2);
                                        $(el).html($_number);
                                    }
                                });

                                _self.html('Quay lại ngay');
                                _self.removeClass('disabled');
                                $('.js-power-655-quaythu').addClass('da-quay');
                            }, 2000);
                        }
                    }, 1000);
                }, (k + 1) * timeout);
            });
        });
    }

    function quayThuMega() {
        $('.js-btn-quay-thu-mega').on('click', function(e) {
            e.preventDefault();
            var _self = $(this);
            _self.html('Đang quay thử...');
            _self.addClass('disabled');

            if ($('.js-mega-645-quaythu').hasClass('da-quay')) {
                $('.js-mega-645-quaythu .js-num').each(function(k, el) {
                    $(el).addClass('loading');
                    $(el).addClass('js-loading-number');
                    $(el).removeAttr('has-animate');
                    $(el).html('?');
                });
            }

            var timeout = 1500;
            var results = [];
            $('.js-mega-645-quaythu .js-num').each(function(k, el) {
                number_quay_timout = setTimeout(function() {
                    $('.js-num').removeClass('next');
                    if (isNaN($(el).html())) {
                        $(el).addClass('next');
                    }

                    generateNumber();
                    gen_number_quay_timout = setTimeout(function() {
                        var data_index = parseInt($(el).attr('data-index'));

                        var number = Math.floor(Math.random() * 45) + 1;
                        while (results.indexOf(number) != -1) {
                            number = Math.floor(Math.random() * 45) + 1;
                        }

                        results.push(parseInt(number));
                        $_number = pad(number, 2);

                        $(el).removeClass('loading');
                        $(el).removeClass('js-loading-number');

                        $(el).html($_number);

                        if (data_index == 6) {
                            results.sort(function(a, b) {
                                return a - b;
                            });
                            setTimeout(function() {
                                $('.js-mega-645-quaythu .js-num').each(function(k, el) {
                                    $_number = pad(results[k], 2);
                                    $(el).html($_number);
                                });

                                _self.html('Quay lại ngay');
                                _self.removeClass('disabled');
                                $('.js-mega-645-quaythu').addClass('da-quay');
                            }, 2000);
                        }
                    }, 1000);
                }, (k + 1) * timeout);
            });
        });
    }

    function loadMoreKeno() {
        $('.js-btn-load-more-keno').on('click', function(event) {
            event.preventDefault();
            var last_keno_id = $('.js-keno_result-numbers .js-keno-item:last').attr('data-id');
            var _self = $(this);
            var _button_text = _self.html();
            _self.html('Đang tải...');
            $.ajax({
                url: base_api_url+'get/kenos',
                data: {
                    keno_id: last_keno_id
                },
                method: 'post',
                type: 'json',
                success: function(res) {
                    if (res.success) {
                        $('.js-wrap-content-kenos').append(res.html);
                    }
                    _self.html(_button_text);
                }
            });
        });
    }

    function loadMoreKqxs(limit = 7){
        $('.js-load-readmore-kqxs').on('click', function(event) {
            event.preventDefault();
            var _self = $(this);

            var last_date = _self.attr('data-last-date');
            var mien = _self.attr('data-mien');
            var province_id = _self.attr('data-province-id');
            var week_day = _self.attr('data-week-day') || '';
            var _button_text = _self.html();
            _self.html('<span>Đang tải...</span>');
            var url = base_api_url + 'get/xoso/mien/more';
            if(province_id > 0){
                url = base_api_url + 'get/xoso/tinh/more';
            }
            if(week_day != ''){
                url = base_api_url + 'get/xoso/mien/weekday/more';
            }

            $.ajax({
                url: url,
                data: {
                    mien: mien,
                    province_id: province_id,
                    last_date: last_date,
                    week_day: week_day,
                    limit: limit
                },
                method: 'post',
                type: 'json',
                success: function(res) {
                    if (res.success && res.html) {
                        $('.js-wrap-kqxs-inner').append(res.html);
                        _self.attr('data-last-date', res.last_date);
                        configViewTableResult();

                        if(typeof lozad === 'function'){
                            const observer = lozad('.lozad', {
                                rootMargin: '10px 0px', // syntax similar to that of CSS Margin
                                threshold: 0.1 // ratio of element convergence
                            });
                            observer.observe();
                        }
                    }
                    _self.html(_button_text);
                }
            });
        });

        $('.js-load-readmore-loto').on('click', function(event) {
            event.preventDefault();
            var _self = $(this);

            var last_date = _self.attr('data-last-date');
            var mien = _self.attr('data-mien');
            var province_id = _self.attr('data-province-id');
            var week_day = _self.attr('data-week-day') || '';
            var _button_text = _self.html();
            _self.html('<span>Đang tải...</span>');
            var url = base_api_url + 'get/loto/mien/more';
            if(province_id > 0){
                url = base_api_url + 'get/loto/tinh/more';
            }

            $.ajax({
                url: url,
                data: {
                    mien: mien,
                    province_id: province_id,
                    last_date: last_date,
                    week_day: week_day,
                    limit: limit
                },
                method: 'post',
                type: 'json',
                success: function(res) {
                    if (res.success && res.html) {
                        $('.js-wrap-kqxs-inner').append(res.html);
                        _self.attr('data-last-date', res.last_date);
                        configViewTableResult();
                    }
                    _self.html(_button_text);
                }
            });
        });
    }

    function loadMorePostItem(){
        $('.js-load-readmore-post-item').on('click', function(event) {
            event.preventDefault();
            var _self = $(this);

            var last_id = _self.attr('data-last-id');
            var mien = _self.attr('data-mien') || 0;
            var type = _self.attr('data-type');
            var province_id = _self.attr('data-province-id') || 0;
            
            var _button_text = _self.html();
            _self.html('<span>Đang tải...</span>');
            var action = 'reload_more_html_post_item';

            $.ajax({
                url: base_api_url+'get/post/more',
                data: {
                    mien: mien,
                    province_id: province_id,
                    type: type,
                    last_id: last_id
                },
                method: 'post',
                type: 'json',
                success: function(res) {
                    if (res.success && res.html) {
                        $('.js-article-listing').append(res.html);
                        _self.attr('data-last-id', res.last_id);

                        if(typeof lozad === 'function'){
                            const observer = lozad('.lozad', {
                                rootMargin: '10px 0px', // syntax similar to that of CSS Margin
                                threshold: 0.1 // ratio of element convergence
                            });
                            observer.observe();
                        }
                    }
                    _self.html(_button_text);
                    if(res.html == ''){
                        _self.remove();
                    }
                }
            });
        });
    }

    function switchAds(){
        var ads = document.querySelectorAll('ins');
        ads.forEach(ad => {             
            const observer = new MutationObserver( mutations => { 
                mutations.forEach( record => { 
                    if(record.type === 'attributes')
                    {
                        const attrname = record.attributeName;
                        const attrvalue = record.target.getAttribute(attrname);
                        if(attrname === 'data-ad-status' && attrvalue === 'unfilled'){
                            // FIX LAI CHO CLASS WRAP CSS
                            if($('.atr-ad-slot').length){
                                $(ad).closest('.atr-ad-slot').html('<div data-type="_mgwidget" data-widget-id="1683365"></div>');
                                (function(w,q){w[q]=w[q]||[];w[q].push(['_mgc.load'])})(window,'_mgq');
                            }
                        }                  
                    }
                });
            });
            
            observer.observe(ad, { 
                attributes: true,
                attributeFilter: ['data-ad-status'] 
            });
        });
    }

    // Hàm hiển thị tooltip
    function showTooltip(event) {
        const message = event.target.getAttribute("data-tooltip");
        tooltip.textContent = message;
        displayTooltip(event);

        if(typeof ga === 'function'){
            ga('send', 'event', 'Tooltip', 'hover', 'Xem tooltip '+message);
        }
    }

    // Hàm ẩn tooltip
    function hideTooltip() {
        tooltip.style.display = 'none';
    }

    function displayTooltip(event){
        tooltip.style.display = 'block';
        const rect = event.target.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        // Tính toán vị trí mặc định
        let left = rect.left + window.scrollX + 10;
        let top = rect.bottom + window.scrollY + 10;

        // Điều chỉnh vị trí nếu tooltip tràn ra ngoài rìa phải
        if (left + tooltipRect.width > window.innerWidth) {
            left = rect.right + window.scrollX - tooltipRect.width - 10;
        }

        // Điều chỉnh vị trí nếu tooltip tràn ra ngoài rìa trái
        if (left < 0) {
            left = 10; // Gắn sát cạnh màn hình
        }

        // Điều chỉnh nếu tooltip tràn ra khỏi rìa dưới màn hình
        if (top + tooltipRect.height > window.innerHeight) {
            top = rect.top + window.scrollY - tooltipRect.height - 10;
        }

        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
    }

    function toggleTooltip(event) {
        var message = event.target.getAttribute('data-tooltip');
        tooltip.textContent = message;

        if (tooltip.style.display === 'block') {
            tooltip.style.display = 'none';
        } else {
            displayTooltip(event);
        }

        event.stopPropagation();
    }
    document.addEventListener("click", (event) => {
        if (!event.target.classList.contains("tooltip-target")) {
          hideTooltip();
        }
    });
    // Di chuyển tooltip
    function moveTooltip(event) {
        const rect = event.target.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        let left = event.pageX + 10;
        let top = event.pageY + 10;

        // Điều chỉnh nếu tràn ra ngoài màn hình
        if (left + tooltipRect.width > window.innerWidth) {
            left = event.pageX - tooltipRect.width - 10;
        }

        if (top + tooltipRect.height > window.innerHeight) {
            top = event.pageY - tooltipRect.height - 10;
        }

        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
    }
    function processTooltip(){
        tooltip = document.getElementById('custom_tooltip');
        const targets = document.querySelectorAll('.tooltip-target');

        targets.forEach(target => {
            if(!jBody.hasClass('mobile')){
                target.addEventListener('mouseenter', showTooltip);
                target.addEventListener('mousemove', moveTooltip);
                target.addEventListener('mouseleave', hideTooltip);
            }

            if(jBody.hasClass('mobile')){
                target.addEventListener('click', toggleTooltip);
            }
        });
    }

    function processSubmitFormFront() {
        if(!$(".js-form-submit-data").length) return;
		var self = this;
		$(".js-form-submit-data").on("submit", function (event) {
            event.preventDefault();
            //if(!$(this).valid()) return;

			if (self.is_requesting) return;
			self.is_requesting = true;

			var action_url = $(this).attr("data-action-url");
			if (!action_url) return;

            var _self = $(this);
            var html_button = _self.find(".js-btn-hoan-tat").html();

            var formData = new FormData(this);

			$.ajax({
				url: action_url,
                data: formData,
                processData: false,
                contentType: false, 
				type: "POST",
				dataType: "json",
				beforeSend: function () {
					_self.find(".js-btn-hoan-tat").text("Đang xử lí...");
				},
				success: function (data) {
                    _self.find(".js-btn-hoan-tat").html(html_button);
					self.is_requesting = false;
				},
				error: function (data) {
                    _self.find(".js-btn-hoan-tat").html(html_button);
					self.is_requesting = false;
				}
			});
        });
        
        $(".js-form-submit-data").validate({
            submitHandler: function(form, event) {
                event.preventDefault();

                if (self.is_requesting) return;
                self.is_requesting = true;

                var _self = $(form);
                var action_url = _self.attr("data-action-url");
                if (!action_url) return;

                var html_button = _self.find(".js-btn-hoan-tat").html();
                var formData = new FormData(_self);

                $.ajax({
                    url: action_url,
                    data: formData,
                    processData: false,
                    contentType: false, 
                    type: "POST",
                    dataType: "json",
                    beforeSend: function () {
                        _self.find(".js-btn-hoan-tat").text("Đang xử lí...");
                    },
                    success: function (data) {
                        _self.find(".js-btn-hoan-tat").html(html_button);
                        self.is_requesting = false;
                    },
                    error: function (data) {
                        _self.find(".js-btn-hoan-tat").html(html_button);
                        self.is_requesting = false;
                    }
                });
                //form.submit();
            },
            errorPlacement: function($error, $element) {
               
                var input_group = $element.closest('.input-group') || $element.closest('.form-group');
                if(input_group.find('.js-post-warnings').length){
                    $error.appendTo(input_group.find('.js-post-warnings'));
                }else{
                    var el_parent = input_group.length > 0 ? input_group.parent() : $element.parent();
                    let customError = $('<p class="error-box"></p>');
                    $error.addClass('error-message');
                    $error.appendTo(customError);
                    customError.appendTo(el_parent);
                }
            }
        });

    }

    function affAdds(){
        var adKey = 'shopeeAdClosedAt';
        var delayMinutes = 5; // thời gian chờ trước khi hiển thị lại
        var buttonImages = [
            '/images/ads/btn-ads-1.png',
            '/images/ads/btn-ads-2.png',
            '/images/ads/btn-ads-3.png',
            '/images/ads/btn-ads-4.png',
            '/images/ads/btn-ads-5.png',
            '/images/ads/btn-ads-6.png',
            '/images/ads/btn-ads-7.png',
            '/images/ads/btn-ads-8.png',
            '/images/ads/btn-ads-9.png',
            '/images/ads/btn-ads-10.png',
            '/images/ads/btn-ads-11.png'
        ];
        var urls = window.aff_urls.replace(/&quot;/g, '"').replace(/\\\//g, '/');
        urls = JSON.parse(urls);

        var index = Math.floor(Math.random() * buttonImages.length);
        var randomImg = buttonImages[index] || '/images/ads/btn-ads-1.png';
        var url_index = Math.floor(Math.random() * urls.length);
        var url = urls[url_index] || 'https://s.shopee.vn/7phZa37Cjp';
        $('.js-ads-image').css({
            'background-image': `url(${randomImg})`,
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            'background-size': 'contain',
            'width': '100%',
            'height': '100%'
        });
        $('.js-ads-link').attr('href', url);
    
        var closedAt = parseInt(localStorage.getItem(adKey), 10) || 0;
        var shouldShowAd = false;
        if (isNaN(closedAt)) shouldShowAd = true;

        var now = Date.now();
        shouldShowAd = (now - closedAt) > delayMinutes * 60 * 1000;

        if (!shouldShowAd) {
            $('.js-ads-wrapper').addClass('hidden');
        }

        $('.js-ads-wrapper .js-btn-close').on('click', function(e){
            e.preventDefault();

            const now = Date.now();
            localStorage.setItem(adKey, now.toString());
            $('.js-ads-wrapper').addClass('hidden');
        });
    }

    if(typeof window.recaptchaCallback !== undefined){
        window.recaptchaCallback = function(response){
            if($('.js-form-submit-data').length){
                $('.js-form-submit-data').find('button[type="submit"]').prop('disabled', false);
                $('.js-form-submit-data').find('button[type="submit"]').removeClass('disabled');
            }else{
                $('.g-recaptcha').closest('form').find('button[type="submit"]').prop('disabled', false);
                $('.g-recaptcha').closest('form').find('button[type="submit"]').removeClass('disabled');
            }
        };
    }
});
